















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";
import { IPageConfig, IPageSrc } from "@/@types/filoxenia-config/nav-bar";
import { FOLDER_ROUTE } from "@/services/nav-panel/nav-model";

interface IEditPatch {
  name: Record<string, string>;
  grid: number;
  src: IPageSrc;
  params?: IPageConfig["params"];
  show: boolean;
  active: boolean;
}

const MATERIAL_ICONS: Array<string> = [
  "circle",
  "home",
  "folder",
  "folder2",
  "tv",
  "movie",
  "music-note",
  "mic",
  "book",
  "newspaper",
  "map",
  "geo-alt",
  "shop",
  "cart",
  "wifi",
  "phone",
  "globe",
  "calendar-week",
  "clock",
  "image",
  "camera-video",
  "gamepad",
  "people",
  "cup-hot",
  "chat-dots",
  "bell",
  "info-circle",
  "star",
  "heart",
  "lightning",
  "water",
  "sun",
];

@Component({ components: { StandartModal } })
class NavPageEditModal extends Vue {
  @Prop({ type: Object, default: null }) page!: IPageConfig | null;
  @Prop({ type: String, default: "palette" }) placement!: string;
  @Prop({ type: Boolean, default: false }) canDelete!: boolean;
  @Prop({ type: Boolean, default: false }) canEditShow!: boolean;
  @Prop({ type: Boolean, default: false }) saving!: boolean;

  name = "";
  grid = 1;
  icon = "circle";
  svg = "";
  show = true;
  active = false;

  iconFolder = "main/configuration/icons";

  get locale(): string {
    return String(this.$i18n.locale);
  }

  get localeLabel(): string {
    return this.locale.toUpperCase();
  }

  get iconOptions(): Array<{ value: string; text: string }> {
    return MATERIAL_ICONS.map((icon) => ({ value: icon, text: icon }));
  }

  get showGrid(): boolean {
    return this.placement !== "min";
  }

  get previewImage(): string {
    const name = this.svg || "";
    if (!name) return "";
    const svgName = name.endsWith(".svg") ? name : `${name}.svg`;
    return this.$getWebImage(svgName, this.iconFolder);
  }

  get previewIcon(): string {
    return this.icon || "circle";
  }

  sync(): void {
    if (!this.page) return;
    this.name = this.$getLocale(this.page.name) || "";
    this.grid = Number(this.page.grid) || 1;
    this.show = !!this.page.show;
    this.active = !!this.page.active;
    const icon = this.page.src?.icon;
    this.icon =
      icon && typeof icon === "object" && icon.icon
        ? icon.icon
        : this.page.route === FOLDER_ROUTE
        ? "folder2"
        : "circle";
    this.svg = this.page.src?.svg || "";
  }

  onIconChange(): void {
    this.svg = "";
  }

  onSvgChange(): void {
    if (this.svg) this.icon = "";
  }

  get patch(): IEditPatch {
    return {
      name: { ...(this.page?.name || {}), [this.locale]: this.name },
      grid: this.grid,
      src: {
        background: this.page?.src?.background || "",
        poster: this.page?.src?.poster || "",
        image: this.page?.src?.image || "",
        icon: this.icon ? { icon: this.icon, lib: "material" } : "",
        svg: this.svg,
      },
      params: {
        ...(this.page?.params || {}),
        tv: {
          ...(this.page?.params?.tv || {}),
          variant: {
            ...(this.page?.params?.tv?.variant || {}),
            grid: this.grid,
          },
        },
      },
      show: this.show,
      active: this.active,
    };
  }

  onSave(): void {
    if (!this.page) return;
    this.$emit("save", { page: this.page, patch: this.patch });
  }
}
export default NavPageEditModal;
